import eventBus from '../event_bus'

let slideStartingIndex = 0
let selectedThumbnailIndex = 0

function addThumbnailFocus (galleryThumbnails, targetThumbnail) {
  galleryThumbnails.forEach(galleryThumbnail => {
    galleryThumbnail.classList.remove('gallery__thumbnail--active')
  })

  targetThumbnail.classList.add('gallery__thumbnail--active')
}

function getMediaSlider (targetGalleryModal) {
  return document.querySelector(`#${targetGalleryModal} carwow-media-slider`)
}

function handleThumbnailClicks (galleryThumbnails) {
  galleryThumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', () => {
      const previousSelectedThumbnailIndex = selectedThumbnailIndex
      selectedThumbnailIndex = parseInt(thumbnail.dataset.galleryThumbnailIndex, 10)

      // only do something if the thumbnail has not been clicked already
      if (selectedThumbnailIndex !== previousSelectedThumbnailIndex) {
        const targetSlider = thumbnail.dataset.galleryThumbnailForSlider

        eventBus.emit('gallery-thumbnail-click', {
          targetSlider,
          thumbnailIndex: selectedThumbnailIndex
        })
      }
    })
  })
}

function handleOpenCtaClicks (container) {
  container.querySelectorAll('[data-open-gallery]').forEach(cta => {
    const galleryName = cta.getAttribute('for').replace('-open', '')
    const gallery = container.querySelector(`[data-gallery-id='${galleryName}']`)
    if (!gallery) return
    const targetGalleryModal = gallery.dataset.galleryId + '-modal'
    const targetMediaSlider = getMediaSlider(targetGalleryModal)

    cta.addEventListener('click', () => {
      if (cta.hasAttribute('data-gallery-starting-index')) {
        slideStartingIndex = parseInt(cta.dataset.galleryStartingIndex, 10)
      }

      eventBus.emit('open-gallery-cta-click', {
        targetSlider: (targetMediaSlider && targetMediaSlider.id),
        slideStartingIndex
      })

      const openGalleryEvent = new CustomEvent('open-gallery-new-click', {
        detail: {
          targetGallery: targetMediaSlider && targetMediaSlider.id,
          slideStartingIndex
        }
      })
      document.dispatchEvent(openGalleryEvent)

      gallery.dataset.galleryOpen = true
    })

    const overlay = document.querySelector(`#${targetGalleryModal} .gallery`)
    if (overlay) {
      document.querySelector(`#${targetGalleryModal} .gallery`).addEventListener('click', (event) => {
        if (event.target === overlay) {
          event.stopImmediatePropagation()
          document.querySelector(`#${targetGalleryModal}`).querySelector('[data-gallery-close]').click()
        }
      })
    }
  })
}

function updateThumbnailFocus () {
  eventBus.on('slider-slide-change', (e) => {
    if (!e.inGallery) return

    const galleryThumbnails = document.querySelectorAll(`[data-gallery-thumbnail-for-slider='${e.galleryId}']`)
    const targetThumbnail = document.querySelector(`[data-gallery-thumbnail-for-slider='${e.galleryId}'][data-gallery-thumbnail-index='${e.currentSlideIndex}']`)
    selectedThumbnailIndex = e.currentSlideIndex

    if (targetThumbnail) {
      addThumbnailFocus(galleryThumbnails, targetThumbnail)
    }
  })
}

function resetGallery () {
  slideStartingIndex = 0
  selectedThumbnailIndex = 0

  const openGallery = document.querySelector('[data-gallery-open]')
  if (!openGallery) return

  const targetGalleryModal = openGallery.dataset.galleryId + '-modal'
  const targetMediaSlider = getMediaSlider(targetGalleryModal)

  eventBus.emit('close-gallery-click', {
    targetSlider: targetMediaSlider && targetMediaSlider.id
  })

  delete openGallery.dataset.galleryOpen
}

function handleGalleryClose (container) {
  container.querySelectorAll('[data-gallery-close]').forEach(button => {
    button.addEventListener('click', resetGallery)
  })
}

const closeOnEscape = {
  handleEvent (e) {
    if (e.keyCode === 27) {
      resetGallery()
    }
  },
  init () {
    document.addEventListener('keyup', this)
  }
}

function hideOnImgError () {
  document.addEventListener('error', (e) => {
    if ((e.target.tagName.toLowerCase() === 'img') && (e.target.closest('[data-gallery-thumbnail-index]'))) {
      const thumbnailsContainer = e.target.closest('[data-gallery-thumbnails]')
      e.target.closest('[data-gallery-thumbnail-index]').remove()
      const thisGalleryThumbnails = thumbnailsContainer.querySelectorAll('[data-gallery-thumbnail-index]')

      // reset indexes
      thisGalleryThumbnails.forEach((thumb, index) => {
        thumb.setAttribute('data-gallery-thumbnail-index', index)
      })
    }
  }, true)
}

export function initGallery (container) {
  const galleries = container.querySelectorAll('[data-gallery-id]')

  galleries.forEach(gallery => {
    const galleryThumbnails = gallery.querySelectorAll('[data-gallery-thumbnail-index]')

    handleThumbnailClicks(galleryThumbnails)
  })

  updateThumbnailFocus()
  handleOpenCtaClicks(container)
  handleGalleryClose(container)
  closeOnEscape.init()
  hideOnImgError()
}
